import { Plus } from "lucide-react";
import { FigmaTypography } from "@libs/zapi-ui/custom";
import { Button } from "@libs/zapi-ui/ds/components/button";
import { EmptyFolderPlusIcon } from "@libs/zapi-ui/assets";

type TProps = {
  hasEdit: boolean;
  onAddProject: () => void;
};

export function EmptyOrgState({ hasEdit, onAddProject }: TProps) {
  return (
    <div
      data-testid="empty-org-state"
      className="flex flex-1 flex-col items-center justify-center gap-[22px] bg-white px-5 py-12"
    >
      <div className="flex flex-col items-center gap-2">
        <EmptyFolderPlusIcon />
        <div className="flex flex-col items-center gap-1">
          <FigmaTypography variant="heading-3" color="zinc900">
            No projects yet
          </FigmaTypography>
          <FigmaTypography variant="body-2" color="zinc500" className="w-[244px] text-center">
            Create your first project and start making decisions with confidence.
          </FigmaTypography>
        </div>
      </div>
      {hasEdit && (
        <Button type="button" data-testid="projects-empty-create-project" onClick={onAddProject}>
          <Plus className="h-4 w-4" />
          New Project
        </Button>
      )}
    </div>
  );
}
